import sourRaspberry from "../assets/images/vape/sourRaspberry.webp";
import aloeCactus from "../assets/images/vape/aloeCatus.webp";
import blueberryCheescake from "../assets/images/vape/blueberryCheescake.webp";
import blueberryCurrant from "../assets/images/vape/blueberryCurrant.webp";
import blueberryRaspberryLemon from "../assets/images/vape/blueberryRaspberryLemon.webp";
import bubblegumMint from "../assets/images/vape/bubblegumMint.webp";
import cherryCola from "../assets/images/vape/cherryCola.webp";
import cranberryGrapes from "../assets/images/vape/cranberryGrapes.webp";
import grapefruit from "../assets/images/vape/grapefruit.webp";
import grapes from "../assets/images/vape/grapes.webp";
import kiwiLemon from "../assets/images/vape/kiwiLemon.webp";
import kiwiPassion from "../assets/images/vape/kiwiPassion.webp";
import mangoPeach from "../assets/images/vape/mangoPeach.webp";
import raspberryGrapefruit from "../assets/images/vape/raspberryGrapefruit.webp";
import skittles from "../assets/images/vape/skittles.webp";
import sourApple from "../assets/images/vape/sourApple.webp";
import strawberryWatermelon from "../assets/images/vape/strawberryWatermelon.webp";
import sweetMint from "../assets/images/vape/sweetMint.webp";
import tangerineSoda from "../assets/images/vape/tangerineSoda.webp";
import watermelonLime from "../assets/images/vape/watermelonLime.webp";
import cherryIce from "../assets/images/vape/cherryIce.webp";
import clear from "../assets/images/vape/clear.webp";
import greenTea from "../assets/images/vape/greenTea.webp";
import melonMint from "../assets/images/vape/melonMint.webp";
import pomegranateLime from "../assets/images/vape/pomegranateLime.webp";
// import vape from '../assets/images/vape/sourRaspberry.webp';

const animations = ["swing-left", "swing-right", "float"];

// bg — цвет подложки карточки под вкус (черновые значения, можно править)
export const products = [
  {
    id: 1,
    title: "Кислая малина",
    vape: sourRaspberry,
    bg: "#C42F51",
    animation: animations[0 % animations.length], // swing-left
  },
  {
    id: 2,
    title: "Алоэ кактус",
    vape: aloeCactus,
    bg: "#3E8E6B",
    animation: animations[1 % animations.length], // swing-right
  },
  {
    id: 3,
    title: "Клюква виноград",
    vape: cranberryGrapes,
    bg: "#C51623",
    animation: animations[2 % animations.length], // float
  },
  {
    id: 4,
    title: "Черника Смородина Энергетик",
    vape: blueberryCurrant,
    bg: "#854495",
    animation: animations[3 % animations.length], // back to swing-left
  },
  {
    id: 5,
    title: "Черника Малина Лимон",
    vape: blueberryRaspberryLemon,
    bg: "#3F55A4",
    animation: animations[1 % animations.length], // swing-right
  },
  {
    id: 6,
    title: "Киви Маракуйя Гуава",
    vape: kiwiPassion,
    bg: "#E8D99B",
    animation: animations[3 % animations.length], // back to swing-left
  },
  {
    id: 7,
    title: "Виноград",
    vape: grapes,
    bg: "#C76997",
    animation: animations[0 % animations.length], // swing-left
  },
  {
    id: 8,
    title: "Черничный чизкейк",
    vape: blueberryCheescake,
    bg: "#6A5F8B",
    animation: animations[2 % animations.length], // float
  },
  {
    id: 9,
    title: "Грейпфрут",
    vape: grapefruit,
    bg: "#D19058",
    animation: animations[3 % animations.length], // back to swing-left
  },
  {
    id: 10,
    title: "Вишня Кола",
    vape: cherryCola,
    bg: "#83323E",
    animation: animations[1 % animations.length], // swing-right
  },
  {
    id: 11,
    title: "Киви Лимон",
    vape: kiwiLemon,
    bg: "#AAC996",
    animation: animations[0 % animations.length], // swing-left
  },
  {
    id: 12,
    title: "Баблгам Мята",
    vape: bubblegumMint,
    bg: "#909BBB",
    animation: animations[1 % animations.length], // swing-right
  },
  {
    id: 13,
    title: "Манго Персик",
    vape: mangoPeach,
    bg: "#DE816A",
    animation: animations[2 % animations.length], // float
  },
  {
    id: 14,
    title: "Малина Грейпфрут",
    vape: raspberryGrapefruit,
    bg: "#DB625C",
    animation: animations[0 % animations.length], // swing-left
  },
  {
    id: 15,
    title: "Скитлс",
    vape: skittles,
    bg: "#CD76AF",
    animation: animations[1 % animations.length], // swing-right
  },
  {
    id: 16,
    title: "Кислое яблоко",
    vape: sourApple,
    bg: "#9BBC8A",
    animation: animations[2 % animations.length], // float
  },
  {
    id: 17,
    title: "Клубника арбуз",
    vape: strawberryWatermelon,
    bg: "#C13367",
    animation: animations[3 % animations.length], // back to swing-left
  },
  {
    id: 18,
    title: "Сладкая мята",
    vape: sweetMint,
    bg: "#73B8AB",
    animation: animations[3 % animations.length], // back to swing-left
  },
  {
    id: 19,
    title: "Мандарин содовая",
    vape: tangerineSoda,
    bg: "#FECC4D",
    animation: animations[1 % animations.length], // swing-right
  },
  {
    id: 20,
    title: "Арбуз Лайм",
    vape: watermelonLime,
    bg: "#E0365D",
    animation: animations[0 % animations.length], // swing-left
  },
  {
    id: 21,
    title: "Вишня Лёд",
    vape: cherryIce,
    bg: "#FFD5E5",
    animation: animations[1 % animations.length], // swing-right
  },
  {
    id: 22,
    title: "Чистый",
    vape: clear,
    bg: "#5A6B7C",
    animation: animations[2 % animations.length], // float
  },
  {
    id: 23,
    title: "Зелёный чай",
    vape: greenTea,
    bg: "#A9E7B3",
    animation: animations[0 % animations.length], // swing-left
  },
  {
    id: 24,
    title: "Дыня Мята",
    vape: melonMint,
    bg: "#FFCDAB",
    animation: animations[1 % animations.length], // swing-right
  },
  {
    id: 25,
    title: "Гранат Лайм",
    vape: pomegranateLime,
    bg: "#FE626C",
    animation: animations[2 % animations.length], // float
  },
  // {
  //   id: 21,
  //   title: 'Кислая малина',
  //   vape: sourRaspberry,
  //   animation: animations[1 % animations.length], // swing-right
  // },
];

export const features = [
  {
    id: 1,
    title: "Vape 1",
    description: "Over 30 vibrant flavors to choose from",
    img: cranberryGrapes,
  },
  {
    id: 2,
    title: "Vape 2",
    description: "Made with high-quality natural ingredients",
    img: skittles,
  },
  {
    id: 3,
    title: "Vape 3",
    description: "Light and smooth for the perfect experience",
    img: strawberryWatermelon,
  },
];
